import type { ReactNode } from 'react'
import { Suspense } from 'react'
import { ErrorBoundary } from '@sentry/react'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { LanguageSelector } from '@jotta/ui/LanguageSelector'
import { AnimateHeight } from '@jotta/ui/AnimateHeight'
import { cn } from '@jotta/utils/css'
import SvgLogoLogin from '@jotta/ui/SvgLogo_loginLight'
import Spinner from '@jotta/ui/Spinner'
import { PublicFooter } from '@jotta/ui/PublicFooter'

export function EntryLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex size-full flex-auto flex-col overflow-auto bg-auth-background p-8 lg:pt-[10vh]">
      <div className="mx-auto flex w-full max-w-md items-center justify-between pb-10">
        <a href="/">
          <PlainBrandIcon icon={SvgLogoLogin} height={40} />
        </a>
        <LanguageSelector className="text-auth-header-foreground" />
      </div>
      <div className="shrink-0 grow">
        <AnimateHeight
          className="mx-auto max-w-md rounded-2xl bg-modal-unbranded shadow-[0_1px_24px_rgba(0,0,0,0.16)]" // Using box-shadow instead of drop-shadow to avoid Safari bug https://stackoverflow.com/questions/76491865/failing-filter-drop-shadow-on-transition-using-safari/78098618
          innerClassName={cn('p-8 lg:p-12')}
        >
          <ErrorBoundary
            fallback={({ error, resetError }) => (
              <ErrorPage error={error} resetError={resetError} hideFooter />
            )}
          >
            <Suspense fallback={<Spinner className="mx-auto" />}>
              {children}
            </Suspense>
          </ErrorBoundary>
        </AnimateHeight>
      </div>
      <PublicFooter currentColor className="text-auth-header-foreground" />
    </div>
  )
}
